export const Constants = {
  TAG_NAME: 'pop-risk-table-component',
  ROW_HEADERS: {
    BENCHMARK: 'Benchmark',
    ADD_PRODUCT: '+ Add product to compare',
  },
  EMPTY_CELL_VALUE: 'N/A',
  NO_DATA_MESSAGE: 'No data available',
} as const;
